import { FaFacebookSquare } from 'react-icons/fa';

import AdComponent from './AdComponent';

export default function SideBarRight() {
  return (
    <div className='mt-4'>
      <AdComponent />
      <div className='order-4 mt-8 flex h-[350px] w-full flex-row justify-around p-4 max-xl:h-auto max-xl:flex-col max-xl:items-center'>
        <div className='mb-4 min-w-[320px] max-w-lg'>
          <h3>Thank You!</h3>
          <p className='mb-4'>for using the Alpaca Tracker!</p>
          <p className='mb-4'>
            If you have any comments, concerns, or suggestions, please let me
            know. I'm always looking for ways to improve the app and better meet
            the needs of the alpaca community
          </p>
          <p className='mb-4'>
            <a
              href='mailto:admin@alpacatracker.com'
              className='hover:opacity-70'
            >
              admin@alpacatracker.com
            </a>
          </p>
          <a
            href='https://www.facebook.com/AlpacaTracker/'
            title='@AlpacaTracker'
            className='hover:opacity-70'
          >
            <div className='flex items-center gap-2'>
              <FaFacebookSquare /> Latest News / Best Answers
            </div>
          </a>
        </div>
        <div className='video-wrapper'>
          <iframe
            title='alpaca tracker demo'
            src='https://www.youtube.com/embed/pCbxZzvPvzc?rel=0'
            frameBorder='0'
            allow='autoplay; encrypted-media'
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}
